import CommentList from './CommentList';
import CommentIcon from '@mui/icons-material/Comment';

const comments = {
    list: CommentList,
    icon: CommentIcon,
};

export default comments;
